// removed by extract-text-webpack-plugin
module.exports = {"root":"NonLoggedBG__root___1H6Ax","image":"NonLoggedBG__image___1wf0J"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/patrick/components/NonLoggedBG/NonLoggedBG.scss
// module id = 2232
// module chunks = 0